import Link from "next/link";
import { Breadcrumb, BreadcrumbItemProps } from "react-bootstrap";
import styled from "styled-components";
import { ColorAA } from "./constants";

const AABreadcrumbItem = (props: BreadcrumbItemProps) => {
  return <Breadcrumb.Item linkAs={Link} {...props} />;
};

const StyledAABreadcrumb = styled(Breadcrumb)`
  --bs-breadcrumb-divider: "|";
`;

const StyledAABreadcrumbItem = styled(AABreadcrumbItem)`
  --bs-breadcrumb-divider-color: ${ColorAA.grey};
`;

Object.assign(StyledAABreadcrumb, {
  Item: StyledAABreadcrumbItem,
});

export default StyledAABreadcrumb;
